import { useEffect, useState } from 'react';

import {
  listRecentSearches, RECENT_SEARCHES_CHANGE_EVENT, RecentSearch,
} from '../lib/recentSearches';

/** Subscribe to on-device recent searches; re-reads on local + cross-tab changes. */
export const useRecentSearches = (): RecentSearch[] => {
  const [searches, setSearches] = useState<RecentSearch[]>(() => listRecentSearches());

  useEffect(() => {
    const handler = () => setSearches(listRecentSearches());
    window.addEventListener(RECENT_SEARCHES_CHANGE_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(RECENT_SEARCHES_CHANGE_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return searches;
};
